<template>
  <div class="jobview">
    <div class="main-wrapper">
      <layout-headerPublic></layout-headerPublic>

      <body>
        <!-- Page Wrapper -->
        <div
          class="page-wrapper job-wrapper"
          style="background-color: #f7f7f7 !important;"
        >
          <!-- Page Content -->
          <div class="content container">
            <!-- Page Header -->
            <div class="page-header">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="page-title">Jobs</h3>
                  <ul class="breadcrumb">
                    <li class="breadcrumb-item">
                      <router-link to="/index">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item active">Jobs</li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- /Page Header -->

            <div class="row">
              <div class="col-md-8">
                <div class="job-info job-widget">
                  <h3 class="job-title">{{ vacancy.jobProfile.title }}</h3>
                  <!-- <span class="job-dept">{{App Development}}</span> -->
                  <ul class="job-post-det">
                    <li>
                      <i class="fa fa-calendar"></i> Post Date:
                      <span class="text-blue">{{
                        new Date(vacancy.periodFrom).toDateString()
                      }}</span>
                    </li>
                    <li>
                      <i class="fa fa-calendar"></i> Last Date:
                      <span class="text-blue">{{
                        new Date(vacancy.periodTo).toDateString()
                      }}</span>
                    </li>
                    <!-- <li><i class="fa fa-user-o"></i> Applications: <span class="text-blue">4</span>
										</li>
										<li><i class="fa fa-eye"></i> Views: <span class="text-blue">3806</span></li> -->
                  </ul>
                </div>
                <div class="job-content job-widget">
                  <div class="job-desc-title">
                    <h4>Job Summary</h4>
                  </div>
                  <div class="job-description">
                    <p>{{ vacancy.description }}</p>
                  </div>
                  <div class="job-desc-title">
                    <h4>Job Description</h4>
                  </div>
                  <div
                    class="job-description"
                    v-html="vacancy.jobRequisition.duties"
                  ></div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="job-det-info job-widget">
                  <a
                    v-if="applicationOpen == true"
                    class="btn job-btn"
                    href="#"
                    data-toggle="modal"
                    data-target="#apply_job"
                    >Apply For This Job</a
                  >
                  <div class="info-list">
                    <span><i class="fa fa-bar-chart"></i></span>
                    <h5>Job Type</h5>
                    <p>{{ vacancy.type }}</p>
                  </div>
                  <div class="info-list">
                    <span><i class="fa fa-money"></i></span>
                    <h5>Salary</h5>
                    <p>
                      ₦{{
                        vacancy.jobProfile.salaryMin
                          .toString()
                          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                      }}
                      - ₦{{
                        vacancy.jobProfile.salaryMax
                          .toString()
                          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                      }}
                    </p>
                  </div>
                  <div class="info-list">
                    <span><i class="fa fa-suitcase"></i></span>
                    <h5>Experience</h5>
                    <p>
                      {{
                        parseInt(vacancy.jobProfile.experience) > 0
                          ? vacancy.jobProfile.experience + " years"
                          : "No experience needed"
                      }}
                    </p>
                  </div>
                  <div class="info-list">
                    <span><i class="fa fa-ticket"></i></span>
                    <h5>Vacancy</h5>
                    <p>{{ vacancy.quantity }}</p>
                  </div>
                  <div class="info-list">
                    <span><i class="fa fa-map-signs"></i></span>
                    <h5>Location</h5>
                    <p>
                      {{ vacancy.jobProfile.company.name }} <br />
                      {{ vacancy.jobProfile.company.address }}
                    </p>
                  </div>
                  <div class="info-list text-center">
                    <a class="app-ends" href="#"
                      >Application ends in
                      {{ getDays(vacancy.periodTo) }} days</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->

          <!-- form 1 -->
          <!-- <div class="modal custom-modal fade" id="apply_job" role="dialog" v-if="form1">
						<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title">Enter Your Email</h5>
									<button type="button" class="close" id="close" data-dismiss="modal" aria-label="Close">
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
								<div class="modal-body">
									<div class="row">
									<div class="col-md-12">
										<div
										class="alert alert-danger alert-dismissible fade show"
										role="alert"
										v-if="error"
										>
										<strong>Error!</strong> {{ error }}
										<button
											type="button"
											class="close"
											data-dismiss="alert"
											aria-label="Close"
										>
											<span aria-hidden="true">&times;</span>
										</button>
										</div>
									</div>
									<div class="col-md-12">
										<div
										class="alert alert-success alert-dismissible fade show"
										role="alert"
										v-if="message"
										>
										<strong>Success!</strong> {{ message }}
										<button
											type="button"
											class="close"
											data-dismiss="alert"
											aria-label="Close"
										>
											<span aria-hidden="true">&times;</span>
										</button>
										</div>
									</div>
                   				</div>
								<form @submit.prevent="applyJob">
								<div class="row">
									<div class="col-sm-12">
									<div class="form-group">
										<label class="col-form-label">Email
										<span class="text-danger">*</span>
										</label>
										<input 
											type="email" 
											id="email"
											name="email"
											class="form-control" 
											v-model.trim="$v.email.$model"
											:class="{ 'is-invalid': submitted && $v.email.$error }"
										/>
										<div
										v-if="submitted && !$v.email.required"
										class="invalid-feedback"
										>
										Email is required
										</div>
									</div>
									</div>                       
								</div>
								<div class="submit-section">
									<button class="btn btn-primary submit-btn" type="submit">Continue</button>
								</div>
								</form>
								</div>
							</div>
						</div>
					</div> -->
          <!-- /form 1 -->

          <!-- Apply Job Modal -->
          <div class="modal custom-modal fade" id="apply_job" role="dialog">
            <div
              class="modal-dialog modal-dialog-centered modal-lg"
              role="document"
            >
              <div class="modal-content">
                <div class="modal-header" v-if="form1">
                  <h5 class="modal-title">Enter Your Email</h5>
                  <button
                    type="button"
                    class="close"
                    id="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-header" v-if="form2">
                  <h5 class="modal-title">Add Your Details</h5>
                  <button
                    type="button"
                    class="close"
                    id="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-header" v-if="form3">
                  <h5 class="modal-title">Enter Your Password</h5>
                  <button
                    type="button"
                    class="close"
                    id="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div
                        class="alert alert-danger alert-dismissible fade show"
                        role="alert"
                        v-if="error"
                      >
                        <strong>Error!</strong> {{ error }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        class="alert alert-success alert-dismissible fade show"
                        role="alert"
                        v-if="message"
                      >
                        <strong>Success!</strong> {{ message }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- form 1 -->
                  <form @submit.prevent="checkExist" v-if="form1">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Email
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            class="form-control"
                            v-model.trim="$v.email.$model"
                            :class="{
                              'is-invalid': submitted && $v.email.$error
                            }"
                          />
                          <div
                            v-if="submitted && !$v.email.required"
                            class="invalid-feedback"
                          >
                            Email is required
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="submit-section">
                      <button class="btn btn-primary submit-btn" type="submit">
                        Continue
                      </button>
                    </div>
                  </form>
                  <!-- /form 1 -->
                  <!-- form 2 -->
                  <form @submit.prevent="applyJob" v-if="form2">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Firstname
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            id="firstName"
                            name="firstName"
                            class="form-control"
                            v-model.trim="$v.firstName.$model"
                            :class="{
                              'is-invalid': submitted && $v.firstName.$error
                            }"
                          />
                          <div
                            v-if="submitted && !$v.firstName.required"
                            class="invalid-feedback"
                          >
                            First Name is required
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Lastname
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            id="lastName"
                            name="lastName"
                            class="form-control"
                            v-model.trim="$v.lastName.$model"
                            :class="{
                              'is-invalid': submitted && $v.lastName.$error
                            }"
                          />
                          <div
                            v-if="submitted && !$v.lastName.required"
                            class="invalid-feedback"
                          >
                            Last Name is required
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Title
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            type="salutation"
                            id="salutation"
                            name="salutation"
                            class="form-control"
                            v-model.trim="$v.salutation.$model"
                            :class="{
                              'is-invalid': submitted && $v.salutation.$error
                            }"
                          />
                          <div
                            v-if="submitted && !$v.salutation.required"
                            class="invalid-feedback"
                          >
                            Title is required
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Gender
                            <span class="text-danger">*</span>
                          </label>
                          <select
                            id="gender"
                            name="gender"
                            class="select form-control"
                            v-model.trim="$v.gender.$model"
                            :class="{
                              'is-invalid': submitted && $v.gender.$error
                            }"
                          >
                            <option disabled>Select Gender</option>
                            <option>Male</option>
                            <option>Female</option>
                          </select>
                          <div
                            v-if="submitted && !$v.gender.required"
                            class="invalid-feedback"
                          >
                            Gender is required
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Phone1
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            id="phone1"
                            name="phone1"
                            class="form-control"
                            v-model.trim="$v.phone1.$model"
                            :class="{
                              'is-invalid': submitted && $v.phone1.$error
                            }"
                          />
                          <div
                            v-if="submitted && !$v.phone1.required"
                            class="invalid-feedback"
                          >
                            Phone 1 is required
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Phone2
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            id="phone2"
                            name="phone2"
                            class="form-control"
                            v-model.trim="$v.phone2.$model"
                            :class="{
                              'is-invalid': submitted && $v.phone2.$error
                            }"
                          />
                          <div
                            v-if="submitted && !$v.phone2.required"
                            class="invalid-feedback"
                          >
                            Phone 2 is required
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Email
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            class="form-control"
                            v-model.trim="$v.email.$model"
                            :class="{
                              'is-invalid': submitted && $v.email.$error
                            }"
                          />
                          <div
                            v-if="submitted && !$v.email.required"
                            class="invalid-feedback"
                          >
                            Email is required
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>Birth Date</label>
                          <div class="cal-icon">
                            <datepicker
                              v-model.trim="$v.birthday.$model"
                              bootstrap-styling
                              class="datetimepicker"
                              type="date"
                              :class="{
                                'is-invalid': submitted && $v.birthday.$error
                              }"
                            />
                          </div>
                          <div
                            v-if="submitted && !$v.birthday.required"
                            class="invalid-feedback"
                          >
                            Birth Date is required
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Address
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            id="address"
                            name="address"
                            class="form-control"
                            v-model.trim="$v.address.$model"
                            :class="{
                              'is-invalid': submitted && $v.address.$error
                            }"
                          />
                          <div
                            v-if="submitted && !$v.address.required"
                            class="invalid-feedback"
                          >
                            Address is required
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label>Upload your CV</label>
                          <div class="custom-file" v-if="!file">
                            <input
                              type="file"
                              name="file"
                              class="custom-file-input"
                              :class="{
                                'is-invalid': submitted && $v.file.$error
                              }"
                              id="cv_upload"
                              @change="onFilePicked"
                            />
                            <div
                              v-if="submitted && !$v.file.required"
                              class="invalid-feedback"
                            >
                              CV is required
                            </div>
                            <label class="custom-file-label" for="cv_upload"
                              >Choose file</label
                            >
                          </div>
                          <div class="row" v-if="file">
                            <div class="col-md-6">
                              <span>{{ fileName }}</span>
                            </div>
                            <div class="col-md-6">
                              <a class="btn btn-primary" @click="changeFile"
                                >Change File</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="submit-section">
                      <button class="btn btn-primary submit-btn" type="submit">
                        Submit
                      </button>
                    </div>
                  </form>
                  <!-- /form 2 -->
                  <!-- form 3 -->
                  <form @submit.prevent="loginApplyJob" v-if="form3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Email
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            class="form-control"
                            v-model.trim="$v.email.$model"
                            :class="{
                              'is-invalid': submitted && $v.email.$error
                            }"
                          />
                          <div
                            v-if="submitted && !$v.email.required"
                            class="invalid-feedback"
                          >
                            Email is required
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Password
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            type="password"
                            id="password"
                            name="password"
                            class="form-control"
                            v-model="password"
                          />
                          <div
                            v-if="submitted && !$v.password.required"
                            class="invalid-feedback"
                          >
                            Password is required
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="submit-section">
                      <button class="btn btn-primary submit-btn" type="submit">
                        Continue
                      </button>
                    </div>
                  </form>
                  <!-- /form 3 -->
                </div>
              </div>
            </div>
          </div>
          <!-- /Apply Job Modal -->
        </div>
        <!-- /Page Wrapper -->
      </body>
    </div>
  </div>
</template>

<script>
import LayoutHeaderPublic from "@/components/layouts/HeaderPublic.vue";
import { jobService } from "@/services/jobService";
import { authenticationService } from "@/services/authenticationService";
import { required } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    LayoutHeaderPublic,
    Datepicker
  },
  data() {
    return {
      vacancy: {
        jobProfile: {
          salaryMin: "",
          salaryMax: "",
          company: {}
        },
        jobRequisition: {}
      },
      form1: true,
      form2: false,
      form3: false,
      firstName: "",
      lastName: "",
      salutation: "",
      gender: "",
      phone1: "",
      phone2: "",
      birthday: "",
      email: "",
      password: "",
      address: "",
      file: null,
      fileName: null,
      message: "",
      error: "",
      loading: false,
      submitted: false
    };
  },
  methods: {
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      //   // console.log(this.fileName)
      // const fileReader = new FileReader()
      // fileReader.addEventListener('load', () => {
      // 	this.file = fileReader.result
      // })
      // fileReader.readAsDataURL(files[0])
      this.file = files[0];
    },

    changeFile() {
      this.file = null;
      this.fileName = "";
    },

    clearModel() {
      this.firstName = "";
      this.lastName = "";
      this.salutation = "";
      this.gender = "";
      this.phone1 = "";
      this.phone2 = "";
      this.birthday = "";
      this.email = "";
      this.address = "";
      this.password = "";
      this.file = null;
    },
    getVacancy() {
      jobService.getVancancyById(this.$route.params.id).then(p => {
        this.vacancy = p;
      });
    },
    checkExist() {
      if (!this.email) {
        this.error = "Email Address is required";
        return;
      }

      jobService.getApplicant(this.email).then(
        app => {
          this.form3 = app;
          this.form2 = !app;
          this.form1 = false;
        },
        error => {
          this.error = error;
        }
      );
    },
    applyJob() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        alert("all field required");
        return;
      }

      jobService
        .applyJob(
          this.$route.params.id,
          this.vacancy.jobProfile.companyId,
          this.firstName,
          this.lastName,
          this.salutation,
          this.gender,
          this.phone1,
          this.phone2,
          this.email,
          this.address,
          this.birthday,
          this.file
        )
        .then(
          p => {
            this.message = "Your application has been submitted successfully";

            $("#close").click();
            this.clearModel();
            this.$router.push("/appdetail/" + p);
          },
          error => {
            this.error = error;
          }
        );
    },
    loginApplyJob() {
      authenticationService.applicantlogin(this.email, this.password).then(
        user => {
          jobService.applyJobByApplicant(this.$route.params.id, user).then(
            p => {
              this.message = "Your application has been submitted successfully";

              $("#close").click();
              this.clearModel();
              this.$router.push("/appdetail/" + p);
            },
            error => {
              this.error = error;
            }
          );
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    getDays(end) {
      // To set two dates to two variables
      var date1 = new Date();
      var date2 = new Date(end);

      // To calculate the time difference of two dates
      var Difference_In_Time = date2.getTime() - date1.getTime();

      // To calculate the no. of days between two dates
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      return parseInt(Difference_In_Days);
    }
  },
  validations: {
    firstName: { required },
    lastName: { required },
    gender: { required },
    salutation: { required },
    email: { required },
    phone1: { required },
    phone2: { required },
    birthday: { required },
    address: { required },
    file: { required }
  },
  computed: {
    applicationOpen: function() {
      return this.getDays(this.vacancy.periodTo) >= 0 ? true : false;
    }
  },
  mounted() {
    this.getVacancy();
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "jobview"
};
</script>



// WEBPACK FOOTER //
// src/components/career/jobview.vue